import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=ffcbcc78&scoped=true&"
var script = {}
import style0 from "./Profile.vue?vue&type=style&index=0&id=ffcbcc78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcbcc78",
  null
  
)

export default component.exports